module.exports = __webpack_public_path__ + "static/img/aux_archers1.e59abbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/aux_archers1.png
// module id = zi+A
// module chunks = 0